import { getOhCookie } from '../../../../shared/cookie';
import { addShells } from '../../../../shared/redis';
import storage from '../../../../shared/storage';
import { GlobalState } from '../../../types.global';

export const trackPageView = async (
  getState: () => GlobalState
): Promise<string> => {
  const state = getState();
  const experiment = state.user.experiment.value;

  const experimentId = `${experiment.experimentId}:${experiment.scenario.id}`;

  if (state.user.ntpVisitCounter === 2) {
    void (async () => {
      const [clickId, campaignId] = await Promise.all([
        getOhCookie('clickId'),
        getOhCookie('campaignId'),
      ]);

      const APP_URL = process.env.APP_URL;
      await fetch(`${APP_URL}/api/track`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId: state.user.userId,
          event: 'Opened_ntp_at_least_2_times',
          clickId,
          campaignId,
        }),
      });
    })();
  }

  if (state.user.ntpVisitCounter === 2) {
    const click_id = await getOhCookie('click_id');
    try {
      await fetch(`https://p.oceanhero.today/?click_id=${click_id}`);
    } catch (err) {
      console.error(err);
    }
  }

  if (state.user.isFirstTimeToday) {
    addShells(state.user.shells?.trackingBufferPrev || 0);
  }

  storage.removeItem('delayedEvents');

  return experimentId;
};
